var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',{attrs:{"title":"게시판 관리"},scopedSlots:_vm._u([{key:"table",fn:function(){return [_c('board-manage-table',{attrs:{"data":_vm.data,"loading":_vm.loading},on:{"refresh":_vm.refreshData}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }